import { render, staticRenderFns } from "./select-component.vue?vue&type=template&id=0a6b2d5e&scoped=true&"
import script from "./select-component.vue?vue&type=script&lang=ts&"
export * from "./select-component.vue?vue&type=script&lang=ts&"
import style0 from "./select-component.vue?vue&type=style&index=0&id=0a6b2d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b2d5e",
  null
  
)

export default component.exports